import takeRequest from '~/store/takeRequest';
import { getMedicalCertificate } from './actions';

export function* getMedicalCertificateSaga() {
  yield takeRequest(getMedicalCertificate);
}
